<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 注意事项文字 -->
        <transition>
          <div class="app-text" v-if="attentionStatus&&attentionText">
            <div class="title" @click="shownote()">
                <img src="../assets/images/text.png" />
                <span  v-show="lang == 'cn'">注意</span>
                <span  v-show="lang == 'en'">NOTE</span>
            </div>
            <div class="content" v-html="attentionText" v-show="is_hidenote"></div>
          </div>
        </transition>
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g class="toolbar-item" @click="openLink()">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">官 网</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="36" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Website</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']" @click="selectToobar('upper')">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="43" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">换 网</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="16px" x="5" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">Screen changing</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="43" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">选 配</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="35" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Option</textPath>
                            </text>
                        </g>
                        <!-- <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="45" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">选 配</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="46" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Type</textPath>
                            </text>
                          </g> -->
                          <!-- 椭圆  A(rx, ry, xr, laf, sf, x, y)
                          rx: 椭圆X轴半径
                          ry: 椭圆Y轴半径
                          xr: 椭圆旋转角度
                          laf: 是否选择弧长较长的那一段。0: 短边（小于180度）; 1: 长边（大于等于180度）
                          sf: 是否顺时针绘制。0: 逆时针; 1: 顺时针
                          x: 终点X轴坐标
                          y: 终点Y轴坐标 -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'upper'">
                    <div
                      v-for="(item,index) in upperObj"
                      :key="index"
                      :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                      @click="upperAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'down'">
                    <div
                      v-for="(item,index) in downObj"
                      :key="index"
                      :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                      @click="downAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
        </div>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'

    // import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
    // import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
    // import { OutlinePass  } from 'three/examples/jsm/postprocessing/OutlinePass.js';
    // // ShaderPass功能：使用后处理Shader创建后处理通道
    // import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
    // // FXAA抗锯齿Shader
    // import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
    // // SMAA抗锯齿通道
    // import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
    // // 伽玛校正后处理Shader
    // import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader';
    // import { CSS2DRenderer,CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
    // // 引入CSS3渲染器CSS3DRenderer
    // // import { CSS3DRenderer,CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    var scene;

    export default {

        components: {
            Loader,
            Nav,
            language,
        },

        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态
                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字
                is_hidenote:true,


                upperActive: null, //换网步骤
                downActive: 0, //复位步骤
                modelanimationList:[], //动画列表
                settiemoutlist:[],
                isOptional:true,

                lang: 'cn', // 语言
                upperObj:[ //上模选项
                  {
                    id: 0,
                    text: '上柱换网', //菜单显示
                    en_text: 'Screen changing at upper piston', //菜单显示(英文)
                    warn: '<p>1.换网：换网器控制其中一个油缸上移将滤网孔推出，更换过滤网（注意不能同时对两个工位进行换网）</p>',
                    en_warn: '<p>1.Control the movement of the oil cylinder to allow the external mesh to enter the workstation.</p>',
                  },
                  {
                      id: 1,
                      text: '上柱复位', //菜单显示
                      en_text: 'Resetting of upper piston', //菜单显示(英文)
                      warn: '<p>2.复位：更换过滤网后控制油缸进行复位。</p>',
                      en_warn: '<p>2.Open the cover and replace the filter screen.</p>',
                  },
                  {
                      id: 2,
                      text: '下柱换网', //菜单显示
                      en_text: 'Screen changing at lower piston', //菜单显示(英文)
                      warn: '<p>3.换网：换网器控制其中一个油缸上移将滤网孔推出，更换过滤网（注意不能同时对两个工位进行换网）</p>',
                    en_warn: '<p>3.Control the movement of the oil cylinder to allow the external mesh to enter the workstation.</p>',
                  },
                  {
                      id: 3,
                      text: '下柱复位', //菜单显示
                      en_text: 'Resetting of lower piston', //菜单显示(英文)
                      warn: '<p>4.复位：更换过滤网后控制油缸进行复位。</p>',
                      en_warn: '<p>4.Open the cover and replace the filter screen.</p>',
                  },
                ],
                downObj: [ //下模选项
                  {
                    id: 0,
                    text: '带护罩', //菜单显示
                    en_text: 'With shield', //菜单显示(英文)
                  },
                  {
                    id: 1,
                    text: '无护罩', //菜单显示
                    en_text: 'Without shield', //菜单显示(英文)
                  },
                ],
            }
        },
        watch:{
          isOptional:function(neavalue,oldvalue){
            console.log(neavalue,oldvalue);
            if(neavalue){
              this.downActive = 0
            }else{
              this.downActive = 1
            }
          }
        },
        mounted: function () {
            let _this = this;

            _this.initCanvas();

            _this.timer = setInterval(function() {
                if ( !_this.hadLoaded ) {
                    if ( _this.loadprogress < 80 ) {
                        _this.loadprogress += 0.8;
                    } else if ( _this.modelLoaded ) {
                        if ( _this.loadprogress <= 100 ) {
                            _this.loadprogress += 2;
                        } else {
                            _this.hadLoaded = true;
                            clearInterval(_this.timer);
                            _this.timer = null;
                        }
                    }
                }
            }, 20);
            // this.raycasterclick()

            window.addEventListener("resize", _this.onResize, false);
            if(sessionStorage.getItem('language')){
              this.lang = sessionStorage.getItem('language'); // 存入一个值
            }else{
              sessionStorage.setItem('language',this.lang); // 存入一个值
            }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;

              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;

              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true,
                  // 设置对数深度缓冲区，优化深度冲突问题
                  // logarithmicDepthBuffer: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);

              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);

          },

          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;

              _this.scene = new THREE.Scene();
          },

          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 0, 2);
            _this.camera.lookAt(_this.scene.position);
          },

          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;

              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enablePan = false;
              _this.controls.enableZoom = true;
          },

          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();

              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/szhwq/szhwq-me.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                _this.modelanimationList = gltf.animations

                // _this.model.scale.set(0.1, 0.1, 0.1);
                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);
                _this.optimization_model_meaterial_performance()
                // _this.model.getObjectByName("jw").material.color.set("#222")

                _this.model.getObjectByName("xw").visible = false;
                _this.model.getObjectByName("xw2").visible = false;
                // 材质共享问题
                _this.model.traverse(function (object) {
                  if (object.isMesh) {
                    object.material = object.material.clone();
                  }
                })
                // console.log(_this.model.getObjectByName("jw"));
                //加载纹理
                let texture = new THREE.Texture();
                texture.wrapS = THREE.RepeatWrapping;
                // texture.repeat.x = -1;
                // texture.flipY = -1;
                let imgLoader = new THREE.ImageLoader();
                let imgurl=`../../static/model/bshwq/map/backgroundMap.jpg`
                imgLoader.load(imgurl,function(img){
                  //将图片值赋于纹理
                  texture.image = img;
                  texture.needsUpdate = true;
                  //将贴图赋于材质
                  _this.model.getObjectByName("jw").children[0].material.map = texture;
                  // _this.model.getObjectByName("jw2").children[0].material.map = texture;
                })
                _this.animate();

              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            if(_this.mixer){
              let mixerUpdateDelta = _this.clock.getDelta();
              _this.mixer.update( mixerUpdateDelta );
            }
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },

          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
          },

          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },

          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            let _this = this
            if(e == 'upper'){
              this.attentionStatus = true
            }else{
              this.attentionStatus = false
            }
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
              if(_this.clipAction){ //如果有动画则先停止播放
                _this.clipAction.stop()
              }
              _this.initmodel()
              if(_this.settiemoutlist){
                clearInterval(_this.settiemoutlist[0])
                clearInterval(_this.settiemoutlist[1])
                clearInterval(_this.settiemoutlist[2])
              }
            }else{
              this.toobarActive = e;
              // this.downActive = null
            }
          },
          optimization_model_meaterial_performance(){
            let _this = this;
            _this.model.traverse(function (object) {
              if (object.isMesh && object.material.isMeshPhysicalMaterial) {
                console.log(object,'isMeshPhysicalMaterial');
                let now_material = object.material
                // 创建一个新的 MeshStandardMaterial，可以根据需要调整属性
                let materialStandard = new THREE.MeshStandardMaterial({
                  color: now_material.color,
                  roughness: now_material.roughness, // 粗糙度
                  metalness: now_material.metalness, // 金属度
                  normalMap: now_material.normalMap, // 法线贴图
                  roughnessMap: now_material.roughnessMap, // 粗糙贴图
                  normalScale: now_material.normalScale, // 法线贴图强度
                  // 其他属性根据需要进行调整或者添加
                });
                // 将模型的材质替换为新的 MeshStandardMaterial
                object.material = materialStandard;
              }
            })
          },
          /**
           * @description 选配按钮
           */
          showhide(Boolean){
            let _this = this
            _this.initmodel()
            if(_this.settiemoutlist){
              clearInterval(_this.settiemoutlist[0])
              clearInterval(_this.settiemoutlist[1])
              clearInterval(_this.settiemoutlist[2])
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            if(Boolean){
              // _this.ShowHideComponents(["jw","baizhao","huzhao"],true)
            }else{
              _this.ShowHideComponents(["huzhao"],false)
            }
            _this.isOptional = Boolean
          },
          /**
           * @description 换网
           * @param {number} e 换网对象
           */
          upperAnimate: function(item) {
            let _this = this
            _this.upperActive = item.id;
            _this.selectobject = item

            _this.initmodel()
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(_this.settiemoutlist){
              clearInterval(_this.settiemoutlist[0])
              clearInterval(_this.settiemoutlist[1])
              clearInterval(_this.settiemoutlist[2])
            }
            if(item.id == 0){
              _this.ShowHideComponents(["xw"],false)
              // _this.ShowHideComponents(["jw"],true)
              _this.$nextTick(()=>{
                _this.settiemoutlist[0] = setTimeout(() => {
                  _this.ShowHideComponents(["xw"],true)
                }, 2000);
                _this.settiemoutlist[1] = setTimeout(() => {
                  _this.ShowHideComponents(["jw"],false)
                }, 4000);
              })
              var newP = { //新的相机位置
                x: -0.14,
                y: 0.2,
                z: 1.3,
              }
              _this.showhide(false)
            }else if(item.id == 1){
              _this.$nextTick(()=>{
                _this.ShowHideComponents(["xw"],true)
                _this.ShowHideComponents(["jw"],false)
              })
              _this.settiemoutlist[2] = setTimeout(() => {
                _this.showhide(true)
              }, 6000);
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 1.5,
              }
              _this.showhide(false)
            }else if(item.id == 2){
              _this.ShowHideComponents(["xw2"],false)
              // _this.ShowHideComponents(["jw"],true)
              _this.$nextTick(()=>{
                _this.settiemoutlist[0] = setTimeout(() => {
                  _this.ShowHideComponents(["xw2"],true)
                }, 2000);
                _this.settiemoutlist[1] = setTimeout(() => {
                  _this.ShowHideComponents(["jw2"],false)
                }, 4000);
              })
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 1.5,
              }
              _this.showhide(false)
            }else if(item.id == 3){
              _this.$nextTick(()=>{
                _this.ShowHideComponents(["xw2"],true)
                _this.ShowHideComponents(["jw2"],false)
              })
              _this.settiemoutlist[2] = setTimeout(() => {
                _this.showhide(true)
              }, 6000);
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 1.5,
              }
              _this.showhide(false)
            }

            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.id]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候

            _this.transparentComponents(["baizhao","zhongxin"],0.3)

            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            _this.tweenCamera(oldP, oldT, newP, newT);
          },

          /**
           * @description 选配
           * @param {item} e 选配对象
           */
          downAnimate: function(item) {
            let _this = this
            _this.downActive = item.id;
            _this.attentionStatus = false;
            if(item.id == 0){
              _this.showhide(true)
            }else{
              _this.showhide(false)
            }
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                // 声明一个三维向量用来表示某个坐标
                // const worldPosition = new THREE.Vector3();
                // 获取mesh的世界坐标，你会发现mesh的世界坐标受到父对象group的.position影响
                // intersects[0].object.getWorldPosition(worldPosition);
                // console.log('世界坐标',worldPosition);
                // console.log('本地坐标',intersects[0].object.position);
                console.log("射线器返回对象", intersects);

                // if(intersects[0].object.name == 'upperhtmldimension'){
                //   var oldP = { //旧的相机位置
                //     x: _this.camera.position.x,
                //     y: _this.camera.position.y,
                //     z: _this.camera.position.z,
                //   }
                //   var oldT = { //旧的聚焦位置
                //     x: _this.controls.target.x,
                //     y: _this.controls.target.y,
                //     z: _this.controls.target.z,
                //   }
                //   var newT = { //新的聚焦位置
                //     x: intersects[0].object.position.x,
                //     y: intersects[0].object.position.y+100,
                //     z: intersects[0].object.position.z,
                //   }
                //   var newP = { //新的相机位置
                //     x: 480,
                //     y: -20,
                //     z: 1500,
                //   }
                //   _this.upperhtmldimension.visible = false
                //   _this.oldP = oldP
                //   _this.tweenCamera(oldP, oldT, newP, newT);
                //   _this.dialogVisible = true
                //   _this.Product_introduce = _this.Product_info.upper
                // }else if(intersects[0].object.name == 'downhtmldimension'){
                //   var oldP = { //旧的相机位置
                //     x: _this.camera.position.x,
                //     y: _this.camera.position.y,
                //     z: _this.camera.position.z,
                //   }
                //   var oldT = { //旧的聚焦位置
                //     x: _this.controls.target.x,
                //     y: _this.controls.target.y,
                //     z: _this.controls.target.z,
                //   }
                //   var newT = { //新的聚焦位置
                //     x: intersects[0].object.position.x,
                //     y: intersects[0].object.position.y+100,
                //     z: intersects[0].object.position.z,
                //   }
                //   var newP = { //新的相机位置
                //     x: 0,
                //     y: -500,
                //     z: -1500,
                //   }
                //   _this.downhtmldimension.visible = false
                //   _this.oldP = oldP
                //   _this.tweenCamera(oldP, oldT, newP, newT);
                //   _this.dialogVisible = true
                //   _this.Product_introduce = _this.Product_info.down
                // }else if(intersects[0].object.name == 'outerhtmldimension'){ // outerhtmldimension
                //   var oldP = { //旧的相机位置
                //     x: _this.camera.position.x,
                //     y: _this.camera.position.y,
                //     z: _this.camera.position.z,
                //   }
                //   var oldT = { //旧的聚焦位置
                //     x: _this.controls.target.x,
                //     y: _this.controls.target.y,
                //     z: _this.controls.target.z,
                //   }
                //   var newT = { //新的聚焦位置
                //     x: intersects[0].object.position.x,
                //     y: intersects[0].object.position.y+100,
                //     z: intersects[0].object.position.z,
                //   }
                //   var newP = { //新的相机位置
                //     x: 450,
                //     y: -370,
                //     z: 1500,
                //   }
                //   _this.outerhtmldimension.visible = false
                //   _this.oldP = oldP
                //   _this.tweenCamera(oldP, oldT, newP, newT);
                //   _this.dialogVisible = true
                //   _this.Product_introduce = _this.Product_info.outer
                // }
              }else{
                console.log('null');
              }
            })
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
            if (this.lang == 'cn') {
              if(this.selectobject.warn){
                this.attentionText = this.selectobject.warn;
              }else{
                this.attentionText = null
              }
            } else {
              if(this.selectobject.en_warn){
                this.attentionText = this.selectobject.en_warn;
              }else{
                this.attentionText = null
              }
            }
          },
          //初始化状态
          initmodel(){
            let _this = this
            _this.showallcomponents()
            _this.ShowHideComponents(["xw","xw2"],false)
          },
          /**
           * @description 显示所有组件
           */
          showallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              object.visible = true
              if (object.isMesh) {
                object.material.opacity = 1
              }
            })
          },
          /**
           * @description 隐藏所有组件
           */
          hideallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              if(object.isMesh){
                object.visible = false
              }
            })
          },
          /**
           * @description 透明组件/取消透明
           * @param {array} e 透明名列表
           * @param {number} e （透明度）
           * @param {Boolean} e （0透明）or（1取消透明）
           */
          transparentComponents(objectArray,opcity,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              console.log(objectArray);
              console.log(objectArray.length);
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  // _this.model.getObjectByName(objectArray[i]).material = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide, depthWrite: false });
                  // _this.model.getObjectByName(objectArray[i]).material.color.set("#222")
                  _this.model.getObjectByName(objectArray[i]).material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    // _this.model.getObjectByName(objectArray[i]).children[j].material = new THREE.MeshBasicMaterial({ transparent: true, side: THREE.DoubleSide, depthWrite: false });
                    // _this.model.getObjectByName(objectArray[i]).children[j].material.color.set("#222")
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          /**
           * @description 显示隐藏组件
           * @param {array} e 隐藏名列表
           * @param {Boolean} e （0隐藏）or（1显示）
           */
          ShowHideComponents(objectArray,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                _this.model.getObjectByName(objectArray[i]).visible = true
              }
            }else{ //隐藏
              for (let i = 0; i < objectArray.length; i++) {
                // console.log(_this.model.getObjectByName(objectArray[i]),objectArray[i]);
                _this.model.getObjectByName(objectArray[i]).visible = false
              }
            }
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            // 创建精灵材质对象SpriteMaterial
            // const spriteMaterial = new THREE.SpriteMaterial({
            //   color:0x00ffff,//设置颜色
            // });
            // // 创建精灵模型对象，不需要几何体geometry参数
            // const sprite = new THREE.Sprite(spriteMaterial);
            // this.model.add(sprite);

            // this.model.getObjectByName("huzhao").traverse(function (object) {
            //   if (object.type === 'Mesh') {
            //     // object.material.transparent = true;
            //     // object.material.opacity = 0.3;
            //     object.visible = false;
            //   }
            // })
            // this.model.getObjectByName("baizhao").traverse(function (object) {
            //   if (object.type === 'Mesh') {
            //     object.material.transparent = true;
            //     object.material.opacity = 0.3;
            //   }
            // })
            // this.model.getObjectByName("zhongxin").traverse(function (object) {
            //   if (object.type === 'Mesh') {
            //     object.material.transparent = true;
            //     object.material.opacity = 0.3;
            //   }
            // })

          },
        }
    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/szhwq.vue